import * as Yup from 'yup'
import { CREDIT_MODES, MAX_SHORT_DAYS, maxCreditDays } from 'services/CardMachine'

const isValidFee = fee => fee === null || (Number.isFinite(fee) && fee >= 0 && fee <= 100)

const allFees = fees => Object.values(fees ?? {}).flatMap(brandFees => [
  brandFees.pix, brandFees.debit, ...brandFees.credit
])

const isDays = (value, max) => Number.isInteger(value) && value >= 0 && value <= max

// Prazo não informado (null/ausente) é válido: a projeção usa o padrão.
const isValidSettlement = settlement => {
  if (settlement === null || settlement === undefined) return true

  const { pix, debit, credit } = settlement
  const creditModes = CREDIT_MODES.map(mode => mode.value)

  return isDays(pix, MAX_SHORT_DAYS) && isDays(debit, MAX_SHORT_DAYS)
    && creditModes.includes(credit?.mode) && isDays(credit.days, maxCreditDays(credit.mode))
}

const cardMachineValidator = Yup.object().shape({
  name: Yup.string().trim().required('Digite o nome da maquininha').max(64, 'Nome muito longo'),
  fees: Yup.mixed()
    .test('has-brand', 'Escolha ao menos uma bandeira', fees => Object.keys(fees ?? {}).length > 0)
    .test('fees-range', 'As taxas devem estar entre 0% e 100%', fees => allFees(fees).every(isValidFee)),
  settlement: Yup.mixed()
    .test('settlement-range', 'Confira os prazos de recebimento (dias inteiros dentro do limite)', isValidSettlement)
})

export default cardMachineValidator
